import React from 'react';
import { Group, Modal } from '@landr/maestro';
import { StudioPlanCodes } from '@landr/pricing';
import { useAppConfig } from '@landr/mfe';
import AddedToYourStudioPlan from './components/AddedToYourStudioPlan/AddedToYourStudioPlan';
import BuyPlanButton from './components/BuyPlanButton/BuyPlanButton';
import ChooseYourPlan from './components/ChooseYourPlan/ChooseYourPlan';
import FrequencySwitch from './components/FrequencySwitch/FrequencySwitch';
import SamplePlan from './components/SamplePlan/SamplePlan';
import StudioPlan from './components/StudioPlan/StudioPlan';
import UpsellActionsProvider from './context/UpsellActionsContext';
import * as Styled from './styled';
import { BasicDownload } from './components/BasicDownload';
import { PartnerUpsell } from './components/PartnerUpsell/PartnerUpsell';

const UpsellActions = ({
    creditsNeeded,
    showBasicDownload = false,
    offeredStudioPlanCode,
}: {
    creditsNeeded?: number;
    showBasicDownload?: boolean;
    offeredStudioPlanCode:
        | StudioPlanCodes.StudioEssentials
        | StudioPlanCodes.StudioStandard;
}) => {
    const appConfig = useAppConfig();

    return (
        <UpsellActionsProvider
            offeredPlanCodes={[offeredStudioPlanCode, 'samples_pro']}
            creditsNeeded={creditsNeeded}
        >
            <Modal.Section className={Styled.Wrapper}>
                <Modal.Header className={Styled.Header} />
                <Modal.Section className={Styled.Content}>
                    <ChooseYourPlan />
                    <Group direction="vertical" alignItems="stretch">
                        {appConfig.name === 'LANDR' ? (
                            <>
                                <FrequencySwitch />
                                <StudioPlan planCode={offeredStudioPlanCode} />
                                <SamplePlan />
                            </>
                        ) : (
                            <PartnerUpsell />
                        )}
                        {showBasicDownload && <BasicDownload />}
                        <Group.Item>
                            <BuyPlanButton />
                        </Group.Item>
                        {appConfig.name === 'LANDR' && (
                            <AddedToYourStudioPlan />
                        )}
                    </Group>
                </Modal.Section>
            </Modal.Section>
        </UpsellActionsProvider>
    );
};

export default UpsellActions;
